const TabSpinner = () => {
  return (
    <div className="tab-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
export default TabSpinner;
